const isDev = (): boolean => {
  const host = window?.location?.hostname;

  if (!host) {
    return true;
  }

  if (host === 'localhost' || host === '127.0.0.1') {
    return true;
  }

  return false;
};

export default isDev;
